
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ContactoPage() {
  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@300;400;500;600;700&family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      
      <div className="min-h-screen bg-gray-50">
        <Header />
        
        {/* Hero Section */}
        <div className="bg-white">
          <div className="w-full mx-auto text-center flex items-center justify-center min-h-screen" style={{ padding: 'clamp(2rem, 4vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
            <div>
              <h1 
                className="font-light text-gray-900" 
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  fontSize: 'clamp(2.5rem, 5vw, 7rem)',
                  marginBottom: 'clamp(1rem, 2vh, 3rem)'
                }}
              >
                CONTACTO
              </h1>
              <p 
                className="text-gray-900 max-w-[1400px] mx-auto leading-relaxed" 
                style={{ 
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: 'clamp(1rem, 1.2vw, 2rem)',
                  padding: '0 clamp(1rem, 2vw, 3rem)'
                }}
              >
                <b>Estamos aquí para ayudarte a crear el baño de tus sueños.</b>
                <br /><br />
                <b>Nuestro equipo de expertos está disponible para asesorarte en cada paso de tu proyecto.</b>
              </p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="w-full" style={{ padding: 'clamp(2rem, 3vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
          {/* Contact Section */}
          <div className="bg-white rounded-lg overflow-hidden">
            {/* Section Header */}
            <div className="relative">
              <div 
                className="bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center"
                style={{ aspectRatio: '3/2' }}>
                <img
                  src="/images/foto_08.jpg"
                  alt="Muebles de baño personalizados - Contacta con Navamuel"
                  className="w-full h-full object-cover opacity-80"
                />
                <div className="absolute inset-0 bg-[#191a19] bg-opacity-40 flex items-center justify-center">
                  <div className="text-center text-white" style={{ padding: '0 clamp(1rem, 2vw, 3rem)' }}>
                    <h2 
                      className="font-light" 
                      style={{ 
                        fontFamily: 'Playfair Display, serif',
                        fontSize: 'clamp(1.25rem, 2.5vw, 3.5rem)',
                        marginBottom: 'clamp(0.25rem, 0.5vh, 1rem)',
                        lineHeight: '1.2'
                      }}
                    >
                      HABLEMOS DE TU PROYECTO
                    </h2>
                    <p 
                      className="opacity-90" 
                      style={{ 
                        fontFamily: 'Cormorant Garamond, serif',
                        fontSize: 'clamp(0.75rem, 1vw, 1rem)',
                        lineHeight: '1.3'
                      }}
                    >
                      Asesoramiento personalizado y profesional
                    </p>
                    <p 
                      className="opacity-75" 
                      style={{ 
                        fontFamily: 'Cormorant Garamond, serif',
                        fontSize: 'clamp(0.625rem, 0.9vw, 0.875rem)',
                        marginTop: 'clamp(0.125rem, 0.25vh, 0.5rem)',
                        lineHeight: '1.3'
                      }}
                    >
                      Nuestro equipo te acompañará en cada decisión.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
        <section className="contact-form-section py-20 bg-gradient-to-br from-gray-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                {/* Left Column - Contact Info */}
                <div className="contact-info-card bg-white p-8 rounded-2xl shadow-xl border border-gray-100 transform hover:scale-105 transition-all duration-500">
                  <div className="mb-8">
                    <h3 className="text-2xl font-light text-gray-800 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                      Información de Contacto
                    </h3>
                    
                    <div className="space-y-6">
                      <div className="contact-item group">
                        <div className="flex items-start space-x-4">
                          <div className="contact-icon w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-900 text-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                            <i className="ri-map-pin-line text-lg"></i>
                          </div>
                          <div>
                            <h4 className="font-medium text-gray-800 mb-1">Dirección</h4>
                            <p className="text-gray-600 text-sm leading-relaxed">
                              Polígono Industrial - Parcela 15-16<br />
                              45125 Pulgar (Toledo) España
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="contact-item group">
                        <div className="flex items-start space-x-4">
                          <div className="contact-icon w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-900 text-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                            <i className="ri-phone-line text-lg"></i>
                          </div>
                          <div>
                            <h4 className="font-medium text-gray-800 mb-1">Teléfonos</h4>
                            <p className="text-gray-600 text-sm">925 292 003</p>
                            <p className="text-gray-600 text-sm">+34 613 82 46 00 (WhatsApp)</p>
                          </div>
                        </div>
                      </div>

                      <div className="contact-item group">
                        <div className="flex items-start space-x-4">
                          <div className="contact-icon w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-900 text-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                            <i className="ri-mail-line text-lg"></i>
                          </div>
                          <div>
                            <h4 className="font-medium text-gray-800 mb-1">Email</h4>
                            <p className="text-gray-600 text-sm">info@mueblesnavamuel.com</p>
                          </div>
                        </div>
                      </div>

                      <div className="contact-item group">
                        <div className="flex items-start space-x-4">
                          <div className="contact-icon w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-900 text-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                            <i className="ri-instagram-line text-lg"></i>
                          </div>
                          <div>
                            <h4 className="font-medium text-gray-800 mb-1">Instagram</h4>
                            <a 
                              href="https://www.instagram.com/navamuel.banos" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="text-gray-600 text-sm hover:text-gray-800 transition-colors cursor-pointer"
                            >
                              @navamuel.banos
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Contact CTA */}
                <div className="contact-cta-section">
                  <div className="text-center mb-8">
                    <h3 className="text-3xl font-light text-gray-800 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                      ¿Tienes alguna consulta?
                    </h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      Estamos aquí para ayudarte. Envíanos un email y te responderemos lo antes posible.
                    </p>
                  </div>

                  {/* Animated Email Button */}
                  <div className="email-button-container relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-800 rounded-2xl blur-lg opacity-30 animate-pulse"></div>
                    <a
                      href="mailto:info@mueblesnavamuel.com?subject=Consulta desde la web&body=Hola,%0D%0A%0D%0ANombre:%0D%0ATeléfono:%0D%0AConsulta:%0D%0A%0D%0AGracias."
                      className="email-button relative block w-full bg-gradient-to-r from-gray-700 to-gray-900 text-white py-6 px-8 rounded-2xl text-center font-medium text-lg transition-all duration-500 transform hover:scale-105 hover:shadow-2xl group overflow-hidden"
                    >
                      {/* Background Animation */}
                      <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-800 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                      
                      {/* Content */}
                      <div className="relative z-10 flex items-center justify-center space-x-3">
                        <div className="email-icon-wrapper relative">
                          <i className="ri-mail-send-line text-2xl transform group-hover:scale-110 transition-transform duration-300"></i>
                          <div className="absolute inset-0 bg-white/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-500"></div>
                        </div>
                        <span className="email-text">ENVIAR EMAIL</span>
                        <i className="ri-arrow-right-line text-xl transform translate-x-0 group-hover:translate-x-2 transition-transform duration-300"></i>
                      </div>

                      {/* Floating particles effect */}
                      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                        <div className="particle absolute w-1 h-1 bg-white/30 rounded-full animate-bounce" style={{ top: '20%', left: '20%', animationDelay: '0s' }}></div>
                        <div className="particle absolute w-1 h-1 bg-white/30 rounded-full animate-bounce" style={{ top: '60%', left: '80%', animationDelay: '0.5s' }}></div>
                        <div className="particle absolute w-1 h-1 bg-white/30 rounded-full animate-bounce" style={{ top: '80%', left: '30%', animationDelay: '1s' }}></div>
                      </div>
                    </a>
                  </div>

                  {/* Additional Contact Options */}
                  <div className="additional-contact-options mt-8 grid grid-cols-2 gap-4">
                    <a
                      href="tel:925292003"
                      className="contact-option-card bg-white p-4 rounded-xl border border-gray-200 text-center hover:shadow-lg hover:border-gray-300 transition-all duration-300 group"
                    >
                      <div className="w-10 h-10 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-2 group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-phone-line text-lg"></i>
                      </div>
                      <p className="text-sm font-medium text-gray-700">Llamar</p>
                      <p className="text-xs text-gray-500">925 292 003</p>
                    </a>

                    <a
                      href="https://wa.me/34613824600"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-option-card bg-white p-4 rounded-xl border border-gray-200 text-center hover:shadow-lg hover:border-gray-300 transition-all duration-300 group"
                    >
                      <div className="w-10 h-10 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-2 group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-whatsapp-line text-lg"></i>
                      </div>
                      <p className="text-sm font-medium text-gray-700">WhatsApp</p>
                      <p className="text-xs text-gray-500">613 82 46 00</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

          {/* Map Section */}
          <div className="bg-white rounded-lg overflow-hidden" style={{ marginTop: 'clamp(2rem, 3vh, 4rem)' }}>
            <div className="border-b border-gray-200" style={{ padding: 'clamp(1.5rem, 2vh, 2rem) clamp(2rem, 3vw, 4rem)' }}>
              <h3 
                className="font-medium text-gray-900 text-center" 
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  fontSize: 'clamp(1.25rem, 2vw, 2rem)'
                }}
              >
                Encuéntranos
              </h3>
            </div>
            <div style={{ padding: 'clamp(1rem, 2vw, 2rem)' }}>
              <div className="aspect-video w-full rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.123456789!2d-4.2876543!3d39.8234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zUG9sw61nb25vIEluZHVzdHJpYWwsIFB1bGdhciwgVG9sZWRvLCBFc3Bhw7Fh!5e0!3m2!1ses!2ses!4v1642000000000!5m2!1ses!2ses"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de ubicación Muebles Navamuel - Polígono Industrial, Pulgar, Toledo"
                ></iframe>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gray-900 text-white rounded-lg overflow-hidden" style={{ marginTop: 'clamp(2rem, 3vh, 4rem)' }}>
            <div 
              className="text-center"
              style={{ padding: 'clamp(3rem, 5vh, 6rem) clamp(2rem, 3vw, 4rem)' }}
            >
              <h3 
                className="font-light text-white" 
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  fontSize: 'clamp(1.5rem, 3vw, 3rem)',
                  marginBottom: 'clamp(1rem, 2vh, 2rem)'
                }}
              >
                ¿Necesitas asesoramiento personalizado?
              </h3>
              <p 
                className="text-white opacity-90 max-w-2xl mx-auto" 
                style={{ 
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: 'clamp(1rem, 1.2vw, 1.25rem)',
                  marginBottom: 'clamp(2rem, 3vh, 3rem)'
                }}
              >
                Nuestro equipo de expertos está disponible para ayudarte con tu proyecto
              </p>
              <div className="flex flex-col sm:flex-row justify-center" style={{ gap: 'clamp(1rem, 1.5vw, 1.5rem)' }}>
                <Link to="/descargas" 
                  className="inline-block bg-white text-gray-900 hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                  style={{ 
                    padding: 'clamp(0.875rem, 1.25vh, 1.25rem) clamp(2rem, 3vw, 3rem)',
                    fontFamily: 'Playfair Display, serif',
                    fontSize: 'clamp(0.875rem, 1vw, 1rem)',
                    fontWeight: '500'
                  }}
                >
                  Descargas técnicas
                </Link>
                <Link to="/nosotros" 
                  className="inline-block border border-white text-white hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                  style={{ 
                    padding: 'clamp(0.875rem, 1.25vh, 1.25rem) clamp(2rem, 3vw, 3rem)',
                    fontFamily: 'Playfair Display, serif',
                    fontSize: 'clamp(0.875rem, 1vw, 1rem)',
                    fontWeight: '500'
                  }}
                >
                  Conoce más sobre nosotros
                </Link>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}